export default {
    book: '{product} Rezerve Et',
    age_limit: 'Sadece {age}+ Yaş',
    change_plan: 'Planı Değiştir',
    upgrade_product: 'Ürünü Yükselt',
    upgrade: 'Yükselt',
    cancel_upgrade: 'Yükseltmeyi İptal Et',
    choose_product: '{product} Seç',
    days: '{count} gün | {count} gün',
    login_register: 'Giriş/Kayıt Ol',
    current: 'Mevcut',
    keyless_benefits: {
        label: 'Araca Doğrudan {0}',
        highlight: 'kiralama servisi™',
        list: {
            cant_lose_the_key: 'Tam Sigorta',
            zero_excess: 'Sıfır Muafiyet',
            phone_as_a_key: 'Anahtar Olarak Telefon',
            straight_to_car: 'Bekleme Yok',
            no_queues: 'Sıra Yok',
            online_id_check: 'Online Kimlik Kontrolü',
            self_checkout: 'Kendi Kendine Teslim Alma',
        },
    },
};
